import React, { FC } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { NavigationItem } from './NavigationItem';
import { INavigationItem } from './Navigation';
import { useRecoilState } from 'recoil';
import { MobileNavigationState } from '../../state/MobileNavigationState';

const StyledNavigation = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  height: calc(100vh - 100%);

  background-color: ${Colors.white};

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  max-width: 100vw;
  overflow: hidden;
  transition: width 100ms ease-out;
  width: ${(props) => props['open'] ? '18rem' : '0'};
`;

const Navigation = styled.nav`
  padding: 1rem 2rem 1rem 0;

  display: flex;
  flex-direction: column;
  align-items: stretch;

  transition: opacity 100ms ease-out;
  opacity: ${(props) => props['open'] ? '1' : '0'};
`;

export interface MobileNavigationProps {
  items: INavigationItem[];
}

export const MobileNavigation: FC<MobileNavigationProps> = (props) => {
  const { items } = props;
  const [showMobileNavigation, setShowMobileNavigation] = useRecoilState<boolean>(MobileNavigationState);

  const openProps = { open: showMobileNavigation };

  return (
    <StyledNavigation {...openProps}>
      {
        items &&
        <Navigation {...openProps}>
          {
            items.map((item) => (
              <NavigationItem
                style={{ padding: '1rem 0' }}
                item={item}
                key={item.text}
                onClick={() => setShowMobileNavigation(false)}
              />
            ))
          }
        </Navigation>
      }
    </StyledNavigation>
  );
};
